import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import * as $ from 'jquery';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MyCONST } from '../../../CONST/myConst';
import { CustomService } from '../../../services/frapper/custom.service';
import { ManagementService } from '../../../services/frapper/management.service';
import { PersonnesService } from '../../../services/frapper/personnes.service';
import { UserService } from '../../../services/frapper/user.service';
import { AlertesService } from '../../../services/public/alertes.service';
import { SignaturePadComponent } from '../../../widgets/signature-pad/signature-pad.component';
import { ViewDetailsFichesComponent } from '../../view-details-fiches/view-details-fiches.component';
import { VisualizePieceComponent } from '../../visualize-piece/visualize-piece.component';
import { AddFonctionComponent } from '../add-fonctions/add-fonction.component';

@Component({
  selector: 'app-config-user',
  templateUrl: './config-user.component.html',
  styleUrls: ['./config-user.component.scss']
})
export class ConfigUserComponent implements OnInit {
 isLinear = true;
  
   data: any;
   type:any;
  
   Emprisonements: any[] = [];
   ContrainteParCorps: any[] = [];
   Reglements: any[] =[]
   signature_user: string = '';
   default_signature:any = null;
   actual_user = null;
   list_functions: any[] =[]
   affiliations = [
    "Pere","Mere","Fratrie","Tuteur" ]
  contacts = [ "Telephone","Email","Faxe" ]
  indentifications = [ "CNI","PASSPORT" ]
  resetForm: FormGroup;
  __selectedProfile = null
  selectedProfile = null
  profil: string = "";
  
  selectedProfession:string = '';
  searchTerm: string = '';
  isProfilListVisible: boolean = false;
  noMatchVisible: boolean = false;
  filteredProfiles: any[] = [];
  allProfiles: any[] = [];

   constructor(private modalService: BsModalService,public options: ModalOptions,
     private ngxService: NgxUiLoaderService,
     private fb: FormBuilder,
     private alerte:AlertesService,
      private personneService: PersonnesService,
      private customservice: CustomService,
      private management:ManagementService,
     private datePipe: DatePipe,
     
     private bsModalRef: BsModalRef,
    private userService: UserService) {
     this.data = options.initialState
      console.log('datat=>personne', this.data);
      
      this.resetForm = this.fb.group(
        {
          currentPassword: ['', Validators.required],

          password: ['', [Validators.required, Validators.minLength(6)]],
          confirmPassword: ['', Validators.required]
        },
        {
          validators: this.passwordsMatchValidator
        }
      );

      this.profil =   localStorage.getItem('profil');
      this.actual_user =   JSON.parse(localStorage.getItem('me')).name
      console.log('datat=>mee', this.actual_user);

   }
 
   passwordsMatchValidator(group: FormGroup) {
    const pass = group.get('password')?.value;
    const confirmPass = group.get('confirmPassword')?.value;
    return pass === confirmPass ? null : { passwordMismatch: true };
  }

  async resetPassword() {
    this.ngxService.start();
    if (this.resetForm.valid) {
      const password = this.resetForm.get('password')?.value;
      const old_password = this.resetForm.get('currentPassword')?.value;
      console.log('Nouveau mot de passe :', password);

      let body_content ={
        "old_password": old_password,
        "new_password": password
      }
    //    {
    //     "doc":  JSON.stringify({
    //         "name": this.data.utilisateur,
    //         "new_password": password,
    //         "logout_all_sessions": 0,
    //         "doctype": "User"
    //     }),
    //     "action":"Save"
    // }
      try {
        let result = await this.userService.resetPasswordUser(body_content)
        console.log('resultat de la réinitialisation du mot de passe:', result);
        if (result) {
          this.alerte.successNotification('Réinitialisation du mot de passe', 'Mot de passe réinitialisé avec succès');
          this.resetForm.reset(); // Réinitialiser le formulaire après succès
          
        } else {
          this.alerte.errorNotification('Réinitialisation du mot de passe', 'Échec de la réinitialisation du mot de passe');
        }

      } catch (error) {
        console.error('Erreur lors de la réinitialisation du mot de passe:', error);
        this.alerte.errorNotification('Réinitialisation du mot de passe', 'Une erreur est survenue');
        
      }finally {
        this.ngxService.stop();
      }
      // Appeler un service pour réinitialiser ici
    }
  }
 
   getFormattedDate(date): string {
     return this.datePipe.transform(date, 'dd-MM-yyyy');
   }
 
   closeModal(){
     this.bsModalRef.hide()
   }

   UpdateValueSelected(value,inputId= null){
    console.log('in updatevalue', inputId);
    
    if (inputId != null && inputId == "_addprofilInput" ) {
      this.__selectedProfile = value
      console.log('in updatevalue', this.__selectedProfile);
    }else{
      this.selectedProfile = value
      console.log('in updatevalue', this.selectedProfile);
    }
    
      
  }

  loadListItems(id,data) {
    const items = data


    if (id == '_addprofilInput') {
      $('.list_item_profil ul').empty(); // Vider la liste avant de la remplir

      items.forEach(item => {
        $('.list_item_profil ul').append('<li>' + item.name + '</li>');

        console.log('profillll',item);
        
      });
    }
  }

  async getAllFunctions() {

    this.ngxService.start();
    try {
      let filter = '[ ["is_judiciaire" ,"=", "1"]]'


      this.list_functions = (await this.management.getAllFunctions(filter)).data;
      this.loadListItems('_addprofilInput',this.list_functions);
      console.log({'the result list_functions': this.list_functions});
      this.ngxService.stop();

    } catch (error) {
      this.ngxService.stop();
    }
  }
   
   getSignature(name_person: any) {
    this.userService.getOneSignature(name_person).then((response) => {
      if (response && response.data) {
        this.data.signature = response.data;
        this.default_signature = MyCONST.API_URL + this.data.signature?.signature

      } else {
        this.data.signature = null;
      }
      console.log('new data after getOnePerson', this.data);
    }
    ).catch((error) => {
      console.error('Error fetching signature:', error);
      this.data.signature = null; // Set to null if there's an error
    }
    );
   }
   async getOnePerson(){
     
     this.ngxService.start()
     try {
      this.data= (await this.personneService.getOnePersonne(this.data.name)).data
      this.getSignature(this.data.utilisateur)
      console.log('new data after getOnePerson', this.data);
      
     } catch (error) {
      
     }finally{
      this.ngxService.stop()
     }
     
   }

  closeWithMessage(message: string) {
    this.bsModalRef.hide();
    this.bsModalRef.onHidden.emit(message);
  }

  openModalVisualPiece(file) {
    const URL=MyCONST.API_URL+file;
    console.log('urllll ', URL);
    const config: ModalOptions = {
      initialState: {
        data: URL,
        url:URL,

        parentModal : null
      }
    }



    // Ouvrir le modal
    const modalRef = this.modalService.show(VisualizePieceComponent, Object.assign({}, config, { class: 'modal-lg ' }));

    // Mettre à jour l'option initialState avec le modalRef
  }

  openSignatureModal(is_new: boolean = false) {
     const config: ModalOptions = {
       initialState: {
         // data: this.libelle_note,
         is_modal: true,
       }
     }
 
     // Ouvrir le modal
     return new Promise<string>((resolve, reject) => {
       const modalRef = this.modalService.show(SignaturePadComponent, Object.assign({}, config, {class:'modal-sm'}));
        modalRef;
        modalRef.onHidden.subscribe((value: string) => {
         resolve(value); // Résoudre la promesse avec la valeur retournée
       });
     }).then(async (value: any) => {
       if (value.message != null) {
        // if (!is_new) {
        //   let body_usersignature = {
            
        //     signature: value
        //   }
        //   await this.userService.updateSignature(this.data.utilisateur,body_usersignature)
        //   this.data.signature = value;
        //   this.getSignature(this.data.utilisateur)
          
        // }else{
        //   let body_usersignature = {
        //     titre: this.data['utilisateur'],
        //     signature: value
        //   }
        //   await this.userService.nouvelleSignature(body_usersignature)
        //   await this.getOnePerson()
        // }
        this.updateSignatureUser(value.signature);
         console.log('canvasOptionssignature:', value);
       }
 
 
     });
   
  }
getTableDataAffiliation() {
      let data = [];
      $("#myTable_affiliation tbody tr").each(function() {
          let row = {};
          row['lien'] = $(this).find('select[name="lien"]').val(); 
          row['nom'] = $(this).find('input[name="nom"]').val(); 
          row['prenom'] = $(this).find('input[name="prenom"]').val();
          data.push(row);
      });
      return data;
    }
  
    getTableDataIdentification() {
      const data: { numero_identifications: string; type: string }[] = [];
    
      $("#myTable tbody tr").each(function () {
        const numero = $(this).find('input[name="numero_didentification"]').val();
        const type = $(this).find('select[name="type_didentification"]').val();
    
        // On ignore les lignes vides si besoin
        if (numero || type) {
          data.push({
            numero_identifications: numero,
            type: type
          });
        }
      });
    
      console.log("Lignes extraites:", data);
      return data;
    }
    getTableDataContact() {
      let data = [];
      $("#myTable_contact tbody tr").each(function() {
          let row = {};
          row['libele'] = $(this).find('input[name="libele"]').val(); 
          row['valeur'] = $(this).find('input[name="valeur"]').val(); 
          row['type'] = $(this).find('select[name="type"]').val();
  
          data.push(row);
      });
      return data;
    }

   async onSubmit(form: NgForm){
    
    let affiliations = this.getTableDataAffiliation();
    let identifications = this.getTableDataIdentification()
    let contacts = this.getTableDataContact()
    let body_content = form.value

    body_content["contact"]= contacts,
    body_content["identifications"]= identifications,
      // body_content['genre'] = this.selectedGenre
    body_content["affiliation"]= affiliations

    try {
        let result = await this.personneService.updatePersonne(this.data.name,body_content)
        if (result != null) {
          this.closeWithMessage("success")
          this.alerte.successNotification("Unité organisationnelle","Mise à jour effectuée")
        }else{
        this.alerte.errorNotification("Unité organisationnelle","erreur pendant l'opération")
        }
        
    } catch (error) {
        this.alerte.errorNotification("Unité organisationnelle", "une erreur est survenue")
        
    }finally{
        this.ngxService.stop()
        
    }
    console.log('body_content:', body_content);
   }

   getCleanFilename(path: string): string {
    // Supprime tout ce qui précède le dernier /
    return path?.split('/').pop() || 'signature.png';
  }

   async updateSignatureUser(file: any) {
    this.ngxService.start()
    let url_file:string= '';
    try {
      const filename = this.getCleanFilename(this.data.signature?.signature);
      console.log('filename:', filename);
      

      url_file = await this.createPiece(this.base64ToFile(file, filename));
      this.signature_user = url_file; // Mettre à jour l'URL de l'image
      this.userService.updateSignature(this.data.utilisateur, { signature: this.signature_user }).then((response) => {
        this.getOnePerson()
        this.alerte.successNotification('Signature', 'Signature mise à jour avec succès');
      }).catch((error) => {
        this.alerte.errorNotification('Signature', 'Erreur lors de la mise à jour de la signature');
        console.error('Erreur lors de la mise à jour de la signature:', error);
      });
    } catch (error) {
      

    }finally {
      this.ngxService.stop()
    }
  }

  async createPiece(file: File | null) : Promise<string> {
    let url_file:string;

     this.ngxService.startLoader('form_step')

    const formData1 = new FormData();
    formData1.append('is_private', '0');
    formData1.append('file', file);

    await this.customservice.createFiles(formData1).then(res => {
      console.log('the createfile=>', res.message.file_url);
      
     url_file  = res.message.file_url
      // Mettre à jour l'URL de l'image
      
       this.ngxService.stopLoader('form_step')
    }).catch(err => {
       this.ngxService.stopLoader('form_step')
      // this.alerte.errorNotification('Pieces', 'Une erreur s\'est produite!');
    });

    return url_file;
  }
  // Fonction pour convertir le base64 en File
  base64ToFile(dataUrl: string, filename: string): File {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
  
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
  
    return new File([u8arr], filename, { type: mime });
  }
  

  onFocus(inputId: string): void {
      this.loadAllProfiles(inputId); // Charge les profils lorsque l'input reçoit le focus
      this.isProfilListVisible = true; // Affiche la liste quand l'input reçoit le focus
    }
  
    // Gérer l'événement blur sur l'input
    onBlur(inputId: string): void {
      setTimeout(() => {
        this.isProfilListVisible = false; 
      }, 200);
    }
  
    // Gérer l'événement input pour filtrer les éléments
    onInput(inputId: string, event: any): void {
      this.searchTerm = event.target.value.toLowerCase();
  
      // Filtrer les profils en fonction du terme de recherche
      this.filteredProfiles = this.allProfiles.filter(profile =>
        profile.name.toLowerCase().includes(this.searchTerm)
      );
  
      // Afficher ou masquer la suggestion "Ajouter" selon qu'il y a une correspondance ou pas
      this.noMatchVisible = this.filteredProfiles.length === 0 && this.searchTerm.trim() !== ''? true : false;
      console.log('dddddd--->',this.noMatchVisible);
      
    }
  
    // Sélectionner un profil dans la liste
    selectProfile(item: any,input_id:string): void {
      // this._selectedProfile = item.name;
      if (input_id === "_addprofilInput") {
        this.__selectedProfile = item.name
        
      }else{
        this.selectedProfession = item.name
      }
     
      this.onInput(input_id, { target: { value: item.name } }); // Met à jour la valeur de l'input
      this.isProfilListVisible = false; // Cache la liste après sélection
    }
  
    async loadAllProfiles(input_id:string): Promise<void> {
      this.ngxService.start(); 
      let intern = 0;
      input_id =="_addprofilInput"? intern = 1:0;
      try {
        const filter = '[ ["is_judiciaire" ,"=",' + intern + ']]'; // Filtre pour récupérer les profils judiciaires ou non judiciaires
        const response = await this.management.getAllFunctions(filter);
        this.allProfiles = response.data;
        this.filteredProfiles = [...this.allProfiles]; 
        this.ngxService.stop();
      } catch (error) {
        this.ngxService.stop(); 
        console.error('Erreur lors du chargement des profils:', error);
      }
    }
    
  
     addItemToApi(itemName: string, inputId: string){
      let isJusticiaire = inputId === "_addprofilInput" ? true : false;
    
      const config: ModalOptions = {
        initialState: {
          is_justiciaire: isJusticiaire,
          default_value: itemName,
        },
      };
    
      let component = AddFonctionComponent;
    
      return new Promise<string>((resolve, reject) => {
        let modalRef = this.modalService.show(component, { ...config, class: 'modal-lg' });
    
        modalRef.onHidden.subscribe((value: string) => {
          resolve(value); // Résoudre la promesse avec la valeur retournée du modal
        });
      }).then(async (value: string) => {
        console.log('in adddecision', value);
    
        if (value === "success") {
          // await this.getAllProfession(inputId);
          this.loadAllProfiles(inputId);
          this.noMatchVisible = false;
    
          this.alerte.successNotification("Profession", 'Profession enregistrée!');
    
          $('#_addpersondecisionInput, #_addprofilInput').val('').trigger('input');
    
  
        }
      });
    }

// initModal(){
//     var self = this;
   

//     $(document).on('focus', '#_addprofilInput', function() {
//       const inputId = $(this).attr('id');
//       const list_item_prof = '.list_item_profil';

//         const listItem = $(this).siblings(list_item_prof);
    
//         // Afficher la liste
//         listItem.show();
    
//         // loadListItems('_addpersondecisionInput');
//       });
    
//       $(document).on('blur', '#_addprofilInput', function() {
//         const inputId = $(this).attr('id');
//         const list_item_prof = '.list_item_profil';

//         const listItem = $(this).siblings(list_item_prof);
    
//         setTimeout(() => {
//           listItem.hide();
//         }, 200);
//       });

    
//       $(document).on('input', '#_addprofilInput', function() {
//         const inputId = $(this).attr('id');
//         const list_item_prof = '.list_item_profil';
//         const searchTerm = $(this).val().toLowerCase();
//         const listItems = $(this).siblings(list_item_prof).find('ul li');
//         const noMatchSuggestion = $(this).siblings('.addperson_no-match-suggestion');
//         const newItemSpan = $(this).siblings('.addperson_no-match-suggestion').find('.new-item');
    
//         let matchFound = false;
    
//         // Filtrer la liste
//         listItems.each(function() {
//           const listItemText = $(this).text().toLowerCase();
//           if (listItemText.indexOf(searchTerm) === -1) {
//             $(this).hide();
//           } else {
//             $(this).show();
//             matchFound = true;
//           }
//         });
    
//         // Si aucune correspondance n'est trouvée, afficher la suggestion d'ajout
//         if (!matchFound && searchTerm.trim() !== '') {
//           noMatchSuggestion.show();
//           newItemSpan.text(searchTerm); // Afficher la saisie de l'utilisateur comme élément suggéré
//         } else {
//           noMatchSuggestion.hide();
          
//         }
//       });

      

      

//         $(document).on('click', '.list_item_profil ul li', function () {
//           const selectedText = $(this).text();
//           $('#_addprofilInput',).val(selectedText); // met la valeur dans l'input
        
//           // 👇 très important : trigger l'événement pour que Angular détecte le changement
//           $('#_addprofilInput',).trigger('input');
        
//           const relatedInput = $(this).siblings('input');
//           const inputId = relatedInput.attr('id');
          
//           self.UpdateValueSelected(selectedText,'_addprofilInput');
        
//           // Cacher la liste
//           $(this).closest(' .list_item_profil ul li').hide();
//         });

//   }
 

  async ngOnInit() {
     var self = this;

    await this.getOnePerson()
    this.getAllFunctions()
    // this.initModal()
      
     let rowCount = 0;
         let rowCount_aff = 0;
         let rowCount_contact = 0;
          var self = this;
         $("#addRowBtn").click(function() {
             
             const options = self.indentifications.map(item => `<option value="${item}">${item}</option>`).join('');
    
            const newRow = `
              <tr>
               <td>
                  <select class="custom-select" name="type_didentification">
                    ${options}
                  </select>
                </td>
                <td>
                  <input class="form-control" type="text" name="numero_didentification" />
                </td>
               
                <td class="col-md-2 col-sm-2">
                  <i class="fas fa-trash text-danger delete" style="font-size: 20px; cursor:pointer;"></i>
                </td>
              </tr>
            `;
             $("#myTable tbody").append(newRow);
             $(document).on("click", ".delete", function() {
               $(this).closest("tr").remove();
               // Mise à jour des numéros de ligne
               $("#myTable tbody tr").each(function(index) {
                   $(this).find("td:first").text(index + 1);
               });
           });
         });
     
         $("#addRowBtn_aff").click(function() {
           
           const options = self.affiliations.map(item => `<option value="${item}">${item}</option>`).join('');
           const newRow = `
               <tr>
                   <td>
                   <select class="custom-select" id="inputGroupSelect01"  name="lien" [(ngModel)]="lien">
                     ${options}
                   </select>
                   </td>
     
                   <td>
                     <input class="form-control" type="text"  name="nom"  [(ngModel)]="nom" />
                   </td>
                   <td>
                   <input class="form-control" type="text"  name="prenom"  [(ngModel)]="prenom" />
                 </td>
                   <td class="col-md-2 col-sm-2"><i class="fas fa-solid fa-trash text-danger delete-aff" style="font-size: 20px;"></i></td> 
               </tr>
           `;
           $("#myTable_affiliation tbody").append(newRow);
     
           $(document).on("click", ".delete-aff", function() {
             $(this).closest("tr").remove();
             // Mise à jour des numéros de ligne
             $("#myTable_affiliation tbody tr").each(function(index) {
                 $(this).find("td:first").text(index + 1);
             });
         });
       });
     
     
       $("#addRowBtn_contact").click(function() {
         
         const options = self.contacts.map(item => `<option value="${item}">${item}</option>`).join('');
         const newRow = `
             <tr>
                <td>
                 <select class="custom-select" id="inputGroupSelect01"  name="type" [(ngModel)]="type">
                   ${options}
                 </select>
                 </td>
     
                 <td>
                   <input class="form-control" type="text"  name="libele"  [(ngModel)]="libele" />
                 </td>
                 <td>
                 <input class="form-control" type="text"  name="valeur"  [(ngModel)]="valeur" />
               </td>
                 <td class="col-md-2 col-sm-2"><i class="fas fa-solid fa-trash text-danger delete-contact" style="font-size: 20px;"></i></td> 
             </tr>
         `;
         $("#myTable_contact tbody").append(newRow);
     
         $(document).on("click", ".delete-contact", function() {
           $(this).closest("tr").remove();
           $("#myTable_contact tbody tr").each(function(index) {
               $(this).find("td:first").text(index + 1);
           });
       });
     });
 

     $(document).ready(function() {
      $(".file-input").on("change", function() {
          // Récupérer le nom du fichier sélectionné
          const fileName = $(this).val().split("\\").pop();
          // Trouver l'élément span à l'intérieur du label parent et mettre à jour son texte
          $(this).parent().find('.file-label').text(fileName);
      });
    });


    
   }
   openModalVisualDoc(data: any) {
     // const URL=MyCONST.DOMAIN+data.fichier
     const config: ModalOptions = {
       initialState: {
         data: data,
 
         parentModal : null
       }
     }
 
      // Ouvrir le modal
      const modalRef = this.modalService.show(ViewDetailsFichesComponent, Object.assign({}, config, { class: 'modal-xl  ' }));
 
      // Mettre à jour l'option initialState avec le modalRef
   }
}
